export interface RosterState {
  loading: boolean
  loadingRosters: boolean
  error: string | null
  rosters: any[]
  selectedRosterId: string
  roster: any
  players: any[]
  affiliates: any[]
  teamOfficials: any[]
  permissions: Record<string, any>
  lockRosterDate: string | null
  canAddPlayersFromRoster: boolean
  isRegistrationOn: boolean
  requireEmail: boolean
  shouldShowWaiver: boolean
}

export enum RosterActionType {
  SET_LOADING = 'SET_LOADING',
  SET_LOADING_ROSTERS = 'SET_LOADING_ROSTERS',
  SET_ROSTER_DATA = 'SET_ROSTER_DATA',
  SET_ERROR = 'SET_ERROR',
  SET_SELECTED_ROSTER = 'SET_SELECTED_ROSTER',
  SET_ROSTERS = 'SET_ROSTERS',
}

export type RosterAction =
  | { type: RosterActionType.SET_LOADING; payload: boolean }
  | { type: RosterActionType.SET_LOADING_ROSTERS; payload: boolean }
  | {
      type: RosterActionType.SET_ROSTER_DATA
      payload: {
        roster: any
        players: any[]
        affiliates: any[]
        teamOfficials: any[]
        permissions: Record<string, any>
        lockRosterDate: string | null
        canAddPlayersFromRoster: boolean
        isRegistrationOn: boolean
        requireEmail: boolean
        shouldShowWaiver: boolean
      }
    }
  | { type: RosterActionType.SET_ERROR; payload: string | null }
  | { type: RosterActionType.SET_SELECTED_ROSTER; payload: string }
  | { type: RosterActionType.SET_ROSTERS; payload: any[] }

export interface RosterContextValue extends RosterState {
  refresh: () => Promise<void>
  refreshingRosterData: boolean
  setSelectedRosterId: (id: string) => void
  loadRosters: () => Promise<void>
}
